import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import classNames from 'classnames/bind';
import { A11y, Autoplay, Controller, Keyboard, Mousewheel, Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
import { useSafeSwiperLoop } from "./hooks/useSafeSwiperLoop";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var Carousel = function Carousel(_ref) {
  var children = _ref.children,
    settings = _ref.settings,
    slideWidthAuto = _ref.slideWidthAuto,
    _ref$paginatePadding = _ref.paginatePadding,
    paginatePadding = _ref$paginatePadding === void 0 ? true : _ref$paginatePadding,
    _ref$customChildren = _ref.customChildren,
    customChildren = _ref$customChildren === void 0 ? false : _ref$customChildren,
    _ref$verticalCentered = _ref.verticalCentered,
    verticalCentered = _ref$verticalCentered === void 0 ? false : _ref$verticalCentered,
    className = _ref.className,
    sendYm = _ref.sendYm;
  var slidesToRender = useSafeSwiperLoop(children, settings);
  return /*#__PURE__*/React.createElement(Swiper, _extends({
    className: cn(className, 'swiper-container', (settings === null || settings === void 0 ? void 0 : settings.navigation) && 'swiper-custom-nav', paginatePadding && 'paginate-padding', verticalCentered && 'swiper-container--align-center'),
    modules: [A11y, Autoplay, Controller, Keyboard, Mousewheel, Navigation, Pagination],
    onActiveIndexChange: function onActiveIndexChange(swiper) {
      return sendYm === null || sendYm === void 0 ? void 0 : sendYm(swiper.activeIndex, swiper.params.slidesPerView);
    },
    onAfterInit: function onAfterInit(swiper) {
      return sendYm === null || sendYm === void 0 ? void 0 : sendYm(swiper.activeIndex, swiper.params.slidesPerView);
    }
  }, settings, {
    "data-t-id": "components-Carousel"
  }), customChildren ? slidesToRender : /*#__PURE__*/React.createElement(React.Fragment, null, slidesToRender.map(function (n, index) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      className: cn(slideWidthAuto && 'slide-width-auto'),
      key: +index
    }, n);
  })));
};
export { Carousel };